import React from 'react'

export function Footer() {
    return (
        <footer className="bd-footer bg-light">
            <div className="container">
                <p className="float-sm-right">© 2026 <a className="text-reset" href="https://zooks.ru"
                                                                   rel="nofollow">Zooks</a></p>
            </div>
        </footer>
    )
}